import { Component, OnInit, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FacilityObject } from '../../../../core/services/facility.model';
import { FacilityService } from '../../../../core/services/facility.service';
import { Subscription } from 'rxjs';
import { CommonUtil } from '../../../../core/Utils/common-util';
import { GetLanguagesService } from '../../../../core/services/get-languages.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-widget-banner',
  templateUrl: './widget-banner.component.html',
  styleUrls: ['./widget-banner.component.scss']
})
export class WidgetBannerComponent implements OnInit {

  @Input() data: any;
  @Input() otherData: {
    "screenSize": string;
    "facilityHours": string;
    "isRTL":boolean;
  };

  currentFacility: FacilityObject;
  showAddWidget: boolean = false;
  widgetMsg: string;
  widgetLang: string;
  rootScopeData: RootScopeDeclare;
  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(private _facilityService: FacilityService,private _rootScopeService: RootScopeService, private _commonUtil: CommonUtil,
    private _langService: GetLanguagesService, private _router: Router,
    private _route: ActivatedRoute, private _amplitudeAnalytics: AmplitudeAnalyticsService) { }

  ngOnInit(): void {
    this.getRootScopeData();
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.widgetMsg = this._commonUtil.replaceValueAsHTMLOnTranslatedText('WIDGET.BANNER.MSG.2', [changes.data.currentValue.validAssetCount]);
    this.widgetLang = this._langService.getLangName(changes.data.currentValue.language);
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }
  
  goToWidget(type: string, stepNo: string): void {
    if (this.rootScopeData.isPageHasUnsavedChanges){
      this.rootScopeData.showUnSavedChangesModal = true;
      this.rootScopeData.pathToNavigate = '/facility/equipment/getWidget';
      this.rootScopeData.pathToNavigateQueryParam = { relativeTo: this._route, state: { data: stepNo } };
    }else{
      this._router.navigate(['getWidget'], { relativeTo: this._route, state: { data: stepNo } });
    }
  }

  showAddWidgetDetails(): void{
    this.showAddWidget=!this.showAddWidget;
  }

}
